import {
  FormControl,
  type FormControlProps,
  FormLabel,
  type FormLabelProps,
  Stack,
  type StackProps,
} from "@chakra-ui/react";
import React from "react";
import { entityProfileModalColors } from "../entityProfileModal.theme";

type FilterBarProps = {
  children: React.ReactNode;
};

type FilterBarItemProps = {
  children: React.ReactNode;
  label: React.ReactNode;
} & Pick<FormControlProps, "flex" | "maxW" | "minW" | "w">;

const filterBarProps: StackProps = {
  alignItems: { base: "stretch", md: "flex-end" },
  direction: { base: "column", md: "row" },
  flexWrap: "wrap",
  gap: 2,
  mb: 5,
  spacing: 0,
};

const filterLabelProps: FormLabelProps = {
  color: entityProfileModalColors.title,
  fontSize: "13px",
  fontWeight: 700,
  mb: 2,
};

export default function EntityProfileFilterBar(props: FilterBarProps) {
  return <Stack {...filterBarProps}>{props.children}</Stack>;
}

export function EntityProfileFilterBarItem(props: FilterBarItemProps) {
  const { children, label, ...formControlProps } = props;

  return (
    <FormControl {...formControlProps}>
      <FormLabel {...filterLabelProps}>{label}</FormLabel>
      {children}
    </FormControl>
  );
}
